import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import {
  selectApiBasePath,
  selectApiDomain,
  selectApiKey,
  selectLogoutUrl,
} from 'src/state/app/appConfigSlice';
import { SessionTimeout } from '@trp-ii-ii-component-library/ii-components';

/**
 * A component to display a session expiration message to the user when appropriate. Will give an
 * option to refresh a token when possible.
 */
const SessionExpiration: FC = () => {
  const apiKey = useSelector(selectApiKey);
  const logoutUrl = useSelector(selectLogoutUrl);
  const apiDomain = useSelector(selectApiDomain);
  const apiBasePath = useSelector(selectApiBasePath);
  const keepAliveUrl = `${apiDomain}${apiBasePath}/ping`;

  return (
    <SessionTimeout logoutURL={logoutUrl} apiKey={apiKey} keepAliveUrl={keepAliveUrl} />
  );
};

export default SessionExpiration;
